import React from 'react';

/**
 * Shared clause wrapper used by both the full /terms + /privacy pages
 * and LegalModal's scrollable popup rendering of the same content.
 */
export const LegalClause: React.FC<{
  id: string;
  n: string;
  title: string;
  children: React.ReactNode;
}> = ({ id, n, title, children }) => (
  <section id={id} className="mb-8 scroll-mt-20">
    <h2 className="text-lg font-semibold text-text-primary mb-3 pb-2 border-b border-border-primary">
      <span className="text-legal-green-700 dark:text-legal-green-400 mr-2">{n}</span>
      {title}
    </h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-text-secondary">{children}</div>
  </section>
);

export default LegalClause;
